import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class MeetingAPI {

  static getList = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    fetch(Config.app.link + 'api/meeting/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static count = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(Config.app.link + 'api/meeting/list/count', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure, Restrict, User) => {
    const filter = [{field: 'model', type: 'model', "condition": "equals",
    value: `${modelType}~${modelId}`}];
    if(Restrict) {
      filter.push({field: 'responsible_person', type: 'multiselect~user', condition: 'equals', value: User});
    }
    const page = 1;
    const perPage = 100;
    fetch(Config.app.link + 'api/meeting/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (call, success, failure) => {
    fetch(Config.app.link + 'api/meeting/add-edit', new Header('POST', call))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/meeting/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getFixedMeetingReportList = (filter, success, failure) => {
    const body = { filters : filter};
    fetch(Config.app.link + 'api/meeting-report/meetingReport', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default MeetingAPI;